<template>
  <div class="print">
    <el-container>
      <el-main ref="main" class="content">
        <div ref="HTMLPrintContent" id="HTMLSendContent"
        style="width: 100%;height: 100%;padding-top:20px;box-sizing: border-box;overflow-y: auto;">
          <div style="display: flex;align-items: center;justify-content: center;font-size: 25px;font-weight: 600;">
            <span>青岛路桥建设集团有限公司</span>
            <span>{{dataForm.documentDraftDeptJson[0].name}}</span>
            <span>发文稿纸</span>
          </div>
          <div style="width: 694px;height: 853px;border: 1px solid #FADADA;margin: 20px auto 0;">
            <!--第一行-->
            <div style=" width: 100%;height: 200px;font-size: 20px;display: flex;">
              <div style=" width: 50%;height: 100%;box-sizing: border-box;padding: 20px 30px 30px;display: flex;flex-direction: column;justify-content: space-between;border-right: 1px solid #DF1717;border-bottom: 1px solid #DF1717;">
                <div>签发</div>
                <div class="info" style="height: 150px;display: flex;align-items: center;justify-content: center;">
                  {{approveUserList.length> 0 ? approveUserList[approveUserList.length - 1].approveUserName: ''}}
                </div>
                <div style=" width: 100%;display: flex;justify-content: flex-end;">
                  <span>{{approveUserList.length> 0 ? approveUserList[approveUserList.length - 1].updateTime: ''}}</span>
                </div>
              </div>
              <div style="width: 50%;height: 100%;">
                <div style="height: 50px;padding: 0px 10px;display: flex;align-items: center;box-sizing: border-box;border-bottom: 1px solid #DF1717;">
                  <div>拟稿部门</div>
                  <div style="padding-left: 20px;">{{dataForm.documentDraftDeptJson[0].name}}</div>
                </div>
                <div style="height: 50px;padding: 0px 10px;display: flex;align-items: center;box-sizing: border-box;border-bottom: 1px solid #DF1717;justify-content: space-between;">
                  <div>拟稿</div>
                  <div style="padding-left: 20px;">{{dataForm.applyUserName}}</div>
                  <div style="display: flex;justify-content: flex-end;">
                    <span>{{dataForm.documentDraftDate}}</span>
                  </div>
                </div>
                <div style="height: 50px;padding: 0px 10px;display: flex;align-items: center;box-sizing: border-box;border-bottom: 1px solid #DF1717;justify-content: space-between;">
                  <div>核稿</div>
                  <div style="padding-left: 20px;"></div>
                  <div style="display: flex;justify-content: flex-end;">
                    <span>{{dataForm.documentApproveDate}}</span>
                  </div>
                </div>
                <div style="height: 50px;padding: 0px 10px;display: flex;align-items: center;box-sizing: border-box;border-bottom: 1px solid #DF1717;">
                  <div>部门负责人签字</div>
                  <div style="padding-left: 20px;">{{approveUserList.length>0?approveUserList[0].approveUserName: ''}}</div>
                </div>
              </div>
            </div>
            <!--第二行-->
            <div style="width: 100%;height: 200px;font-size: 20px;display: flex;">
              <div style="width: 50%;height: 100%;box-sizing: border-box;padding: 20px 30px 30px;display: flex;flex-direction: column;border-right: 1px solid #DF1717;border-bottom: 1px solid #DF1717;">
                <div>审（会）签</div>
                <div style="height: 100%;display: flex;flex-direction: column;justify-content: center;align-items: center;">
                  <div style=" width: 80%;margin-bottom: 10px;display: flex;justify-content: space-between;align-items: center;"
                    v-for="(approveUserItem, approveUserIndex) in approveUserList"
                    :key="'approveUserItem'+approveUserIndex"
                    v-show="approveUserList.length>2&&
                    approveUserIndex!= 0&&
                    approveUserIndex!=approveUserList.length- 1">
                    <div>{{approveUserItem.approveUserName}}</div>
                    <div style="display: flex;justify-content: flex-end;">
                      <span>{{approveUserItem.updateTime}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div style="width: 50%;height: 100%;">
                <div style="height: 50px;padding: 0px 10px;display: flex;align-items: center;box-sizing: border-box;border-bottom: 1px solid #DF1717;justify-content: center;">
                  <div>办公室审核</div>
                </div>
                <div style="height: 50px;padding: 0px 10px;display: flex;align-items: center;box-sizing: border-box;border-bottom: 1px solid #DF1717;">
                  <div>审核</div>
                  <div style="padding-left: 20px;"></div>
                </div>
                <div style="height: 50px;padding: 0px 10px;display: flex;align-items: center;box-sizing: border-box;border-bottom: 1px solid #DF1717;">
                  <div>审修</div>
                  <div style="padding-left: 20px;"></div>
                </div>
                <div style="height: 50px;padding: 0px 10px;display: flex;align-items: center;box-sizing: border-box;border-bottom: 1px solid #DF1717;justify-content: space-between;">
                  <div style="width: 50%;display: flex;align-items: center;">
                    <div>密级</div>
                    <div style="padding-left: 20px;"></div>
                  </div>
                  <div style="width: 50%;display: flex;align-items: center;">
                    <div>期限</div>
                    <div style="padding-left: 20px;"></div>
                  </div>
                </div>
              </div>
            </div>
            <!--第三行-->
            <div style="width: 100%;height: 130px;box-sizing: border-box;padding: 20px 30px 30px;font-size: 20px;border-bottom: 1px solid #DF1717;">
              <div>文件标题</div>
              <div style="width: 100%;height: 80px;display: flex;justify-content: center;align-items: center;">
                {{dataForm.title}}
              </div>
            </div>
            <!--第四行-->
            <div class="fourthInfo" style=" width: 100%;height: 65px;font-size: 20px;border-bottom: 1px solid #DF1717;display: flex;">
              <div class="fourthLeft" style="width: 70%;height: 100%;border-right: 1px solid #DF1717;">
                <div class="fourthItem" style=" height: 100%;padding-left: 30px;display: flex;align-items: center;">
                  <div>发文字号</div>
                  <div style="padding-left: 20px;">{{dataForm.documentNum}}</div>
                </div>
              </div>
              <div>
                <div style=" height: 100%;padding-left: 30px;display: flex;align-items: center;">
                  <div>份数</div>
                  <div style="padding-left: 20px;"></div>
                </div>
              </div>
            </div>
            <!--第五行-->
            <div style="width: 100%;height: 65px;box-sizing: border-box;padding-left: 30px;font-size: 20px;display: flex;align-items: center;border-bottom: 1px solid #DF1717;">
              <div>附件名称</div>
              <div style="width: 80%;padding-left: 20px;">
                <span v-for="(fileItem,fileIndex) in fileList" :key="'fileItem'+ fileIndex">
                  <span v-if="fileIndex<2">
                    <span>{{fileItem.name}}</span>
                    <span v-show="fileIndex!=1">、</span>
                  </span>
                </span>
                <span v-show="fileList.length>=2">等</span>
              </div>
            </div>
            <!--最后一行-->
            <div style="width: 100%;height: 192px;display: flex;">
              <div style="width: 70%;height: 100%;padding: 20px 30px 0px;box-sizing: border-box;border-right: 1px solid #DF1717;font-size: 20px;">
                <div>主送</div>
                <div style="height: 60px;display: flex;justify-content: center;align-items: center;">
                  <span v-for="(item, sendIndex) in dataForm.sendListJson"
                        :key="'item'+ sendIndex"
                  >
                    {{item.name}}
                    <span v-if="(sendIndex+1) != dataForm.sendListJson.length">、</span>
                  </span>
                </div>
                <div>抄送</div>
                <div style="height: 60px;display: flex;align-items: center;flex-wrap: wrap;">
                  <span v-for="(ccItem, ccIndex) in dataForm.ccListJson"
                        :key="'ccItem'+ ccIndex"
                  >
                    {{ccItem.name}}
                    <span v-if="(ccIndex+1) != dataForm.ccListJson.length">、</span>
                  </span>
                </div>
              </div>
              <div style="width: 30%;height: 100%;padding: 20px 30px 30px;box-sizing: border-box;font-size: 20px;">
                <div>备注</div>
                <div style="height: 100px;display: flex;justify-content: center;align-items: center;">
                  {{dataForm.remark}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-main>
      <el-footer class="container">
        <div class="btnMid">
          <el-button type="info" @click="close()">关闭</el-button>
          <el-button type="info" @click="print()">打印</el-button>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import printJS from "print-js";
import {
  getSendDetailService,
} from "@/services/documentServices";
import { queryRealApproveProcessApi } from "@/services/sysSettingService";

export default {
  name: "print",
  data(){
    return {
      id: '',
      dataForm: {
        id:'', //id
        title: '',  //标题
        applyUserName: '',  //拟稿人
        documentNum: '',  //发文字号
        documentTypeId: '',  //发文分类id
        documentDate: '',  //发文日期
        documentDraftDate: '',  //拟稿日期
        documentApproveDate: '',  //核稿日期
        sendListJson: [],  //主送
        ccListJson: [],  //抄送
        documentDraftDeptJson: [{
          name:''
        }],  //部门
        remark: '',  //备注
      },
      approveUserList: [],
    }
  },
  methods: {
    onActive(menuCode) {
      if(this.tabRouteParam.id){
        this.id = this.tabRouteParam.id;
        this.getSendDetail();
      }
    },
    //获取发文详情
    getSendDetail(){
      let paramsData = {
        systemFileInternalId: this.id
      }
      getSendDetailService(paramsData).then( res => {
        if(res.code == 10000000){
          this.dataForm = {
            id: res.data.id,
            title: res.data.title,  //标题
            applyUserName: res.data.applyUserName,  //拟稿人
            documentNum: res.data.documentNum,  //发文字号
            documentTypeId: res.data.documentTypeId,  //发文分类id
            documentDate: res.data.documentDate,  //发文日期
            documentDraftDate: res.data.documentDraftDate,  //拟稿日期
            documentApproveDate: res.data.documentApproveDate,  //核稿日期
            sendListJson: res.data.sendListJson ? JSON.parse(res.data.sendListJson) : "",  //主送
            ccListJson: res.data.ccListJson ? JSON.parse(res.data.ccListJson) : "",  //抄送
            documentDraftDeptJson: JSON.parse(res.data.documentDraftDeptJson),  //部门
            remark: res.data.remark,  //备注
          }
          this.fileList = res.data.attachmentList;
          if(res.data.approveStatus == 3){
            this.queryRealApproveProcess();
          }
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error => {
        this.$message.error("网络请求失败");
      });
    },
    //获取审批人
    queryRealApproveProcess(){
      let paramsData = {
        itemId: this.id,
        approveClass: 'OFFICIAL_DOCUMENT_INTERNAL',
      }
      queryRealApproveProcessApi(paramsData).then( res => {
        if(res.code == 10000000){
          this.approveUserList = res.data;
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error => {
        this.$message.error("网络请求失败");
      });
    },
    // 打印按钮
    print(){
      printJS({
        printable: "HTMLSendContent",
        type: "html",
        targetStyles: ["*"],
        ignoreElements: ["no-print", "bc", "gb"],
        scanStyles: false,
      });
    },
    // 关闭按钮
    close(){
      this.bus.$emit("tabClose", "documentManagePrint");
      this.bus.$emit("navMenuChange", {
        routeId: "documentManage"
      });
    },
  }
}
</script>

<style scoped lang="scss">
  @import "@/assets/css/commonLayout.scss";
  .print {
    height: 100%;
    background-color: white;
    display: flex;
    flex-direction: column;
    .content{
      padding:30px 50px 50px;
    }
    .container{
      width: 900px;
    }
  }
  /deep/.el-container .el-main{
    height: 100%;
  }
  .btnMid {
    width: 300px;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
  }

  .printInfo{
    width: 100%;
    height: 100%;
    padding: 50px;
    box-sizing: border-box;
    overflow-y: auto;
    .printTitle{
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 25px;
      font-weight: 600;
    }
    .printContent{
      width: 794px;
      height: 1123px;
      border: 1px solid #FADADA;
      margin: 40px auto 0;
      .firstInfo{
        width: 100%;
        height: 252px;
        font-size: 20px;
        display: flex;
        .firstLeft{
          width: 50%;
          height: 100%;
          box-sizing: border-box;
          padding: 20px 30px 30px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          border-right: 1px solid #DF1717;
          border-bottom: 1px solid #DF1717;
          .info{
            height: 150px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .time{
            width: 100%;
            display: flex;
            justify-content: flex-end;
          }
        }
        .firstRight{
          width: 50%;
          height: 100%;
          .firstItem{
            height: 63px;
            padding: 0px 10px;
            display: flex;
            align-items: center;
            box-sizing: border-box;
            border-bottom: 1px solid #DF1717;
            .info{
              padding-left: 20px;
            }
          }
          .actFirstItem{
            justify-content: space-between;
            .info{
              padding-left: 0px;
            }
          }
        }
      }
      .secondInfo{
        width: 100%;
        height: 252px;
        font-size: 20px;
        display: flex;
        .secondLeft{
          width: 50%;
          height: 100%;
          box-sizing: border-box;
          padding: 20px 30px 30px;
          display: flex;
          flex-direction: column;
          border-right: 1px solid #DF1717;
          border-bottom: 1px solid #DF1717;
          .info {
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .infoItem {
              width: 80%;
              margin-bottom: 10px;
              display: flex;
              justify-content: space-between;
              align-items: center;
            }
            .infoItem:last-child {
              margin-bottom: 0px;
            }
          }
        }
        .secondRight{
          width: 50%;
          height: 100%;
          .secondItem{
            height: 63px;
            padding: 0px 10px;
            display: flex;
            align-items: center;
            box-sizing: border-box;
            border-bottom: 1px solid #DF1717;
            .info{
              padding-left: 20px;
            }
          }
          .secondItem1{
            justify-content: center;
          }
          .secondItem2{
            justify-content: space-between;
            .secondItemInfo{
              width: 50%;
              display: flex;
              align-items: center;
            }
          }
        }
      }
      .threeInfo{
        width: 100%;
        height: 150px;
        box-sizing: border-box;
        padding: 20px 30px 30px;
        font-size: 20px;
        border-bottom: 1px solid #DF1717;
        .info{
          width: 100%;
          height: 80px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      .fourthInfo{
        width: 100%;
        height: 80px;
        font-size: 20px;
        border-bottom: 1px solid #DF1717;
        display: flex;
        .fourthLeft{
          width: 70%;
          height: 100%;
          border-right: 1px solid #DF1717;
        }
        .fourthItem{
          height: 100%;
          padding-left: 30px;
          display: flex;
          align-items: center;
          .info{
            padding-left: 20px;
          }
        }
      }
      .fifthInfo{
        width: 100%;
        height: 80px;
        box-sizing: border-box;
        padding-left: 30px;
        font-size: 20px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #DF1717;
        .info{
          padding-left: 20px;
        }
      }
      .lastInfo{
        width: 100%;
        height: 308px;
        display: flex;
        .lastLeft{
          width: 70%;
          height: 100%;
          padding: 20px 30px 30px;
          box-sizing: border-box;
          border-right: 1px solid #DF1717;
          font-size: 20px;
          .mainList{
            height: 150px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .sendList{
            height: 100px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
        .lastRight{
          width: 30%;
          height: 100%;
          padding: 20px 30px 30px;
          box-sizing: border-box;
          font-size: 20px;
          .remarksTxt {
            height: 270px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }
  }

</style>
